import { useEffect } from 'react';
import { useDriverOperations } from './useDriverOperations';

export const useInitDriverFuelAssignmentsCards = () => {
  const { getDriverFuelAssignmentsCards } = useDriverOperations();

  useEffect(() => {
    getDriverFuelAssignmentsCards();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
